import Phaser from "phaser";

import { WORLD_CHARACTER_DISPLAY_PX } from "@cold-case/shared/constants";

/** Shared walk bob for local player, co-op peers, and NPCs. */
export const WORLD_CHARACTER_BOB_AMP_PX = 2.8;
export const WORLD_CHARACTER_BOB_SPEED = 0.014;

const LOCAL_PLAYER_PLACEHOLDER_TINT = 0x8899cc;

/** Uniform world scale for local player, peers, and outdoor NPCs. */
export function applyWorldCharacterSprite(vis: Phaser.GameObjects.Sprite): void {
  vis.setDisplaySize(WORLD_CHARACTER_DISPLAY_PX, WORLD_CHARACTER_DISPLAY_PX);
  vis.setOrigin(0.5, 0.9);
}

/** Apply directional art and re-lock display size (Phaser resets size on setTexture). */
export function setWorldCharacterTexture(
  vis: Phaser.GameObjects.Sprite,
  textureKey: string
): void {
  vis.setTexture(textureKey);
  vis.clearTint();
  applyWorldCharacterSprite(vis);
}

/** Placeholder silhouette until rotation art is ready. */
export function setWorldCharacterPlaceholder(
  vis: Phaser.GameObjects.Sprite,
  opts?: { localPlayer?: boolean }
): void {
  vis.setTexture("placeholder_npc");
  applyWorldCharacterSprite(vis);
  if (opts?.localPlayer) {
    vis.setTint(LOCAL_PLAYER_PLACEHOLDER_TINT);
  } else {
    vis.clearTint();
  }
}

/** Vertical sprite offset while walking; zero when idle or reduced motion. */
export function worldCharacterWalkBobY(
  phase: number,
  moving: boolean,
  reducedMotion: boolean
): number {
  if (reducedMotion || !moving) return 0;
  return Math.sin(phase) * WORLD_CHARACTER_BOB_AMP_PX;
}

export function worldCharacterTapRadiusPx(fraction: number): number {
  return Math.round(WORLD_CHARACTER_DISPLAY_PX * fraction);
}
